module.exports = __webpack_public_path__ + "img/InactiveProgress.2c0688ee.svg";